import Router from 'vue-router';

// Framework
import {
    Home,
    Help,
    BriefInfo,
    BriefSteps,
    BriefRules,
    BriefReward,
    Contract,
    Upload,
    Thanks,
    Profile,
    ProfileAbout,
    ProfileVideos,
    ProfileEditGeneral,
    ProfileEditSocial,
    ProfileEditAddress,
    ProfilePrivacy,
    Project,
    Information,
    ProfileEditPreferences,
} from '@skeepers/platform-framework/views/mobile';
import {
    NotFound,
    Forbidden,
} from '@skeepers/platform-framework/views/shared';
import {
    routerStrategy,
} from '@skeepers/platform-framework/data';

// Basic
import {
    BriefWrapper,
} from '@/views/mobile';
import {
    DepositWrapper,
} from '@/views/shared';

export default new Router({
    mode: 'history',
    base: routerStrategy('base') || '/',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: { tracking: 'PLATFORM_HOMEPAGE_VIEW' },
        }, {
            path: '/deposit',
            name: 'deposit',
            redirect: '/deposit/brief/info',
            component: DepositWrapper,
            meta: { auth: true },
            children: [
                {
                    path: '/deposit/brief',
                    name: 'deposit.brief',
                    redirect: '/deposit/brief/info',
                    component: BriefWrapper,
                    meta: { tracking: 'PLATFORM_BRIEF_VIEW' },
                    children: [
                        {
                            path: '/deposit/brief/info',
                            name: 'deposit.brief.info',
                            component: BriefInfo,
                            props: { next: 'deposit.brief.reward' },
                        }, {
                            path: '/deposit/brief/reward',
                            name: 'deposit.brief.reward',
                            component: BriefReward,
                            props: { next: 'deposit.brief.steps' },
                        }, {
                            path: '/deposit/brief/steps',
                            name: 'deposit.brief.steps',
                            component: BriefSteps,
                            props: { next: 'deposit.brief.rules' },
                        }, {
                            path: '/deposit/brief/rules',
                            name: 'deposit.brief.rules',
                            component: BriefRules,
                            props: { next: 'deposit.contract' },
                        },
                    ],
                }, {
                    path: '/deposit/information',
                    name: 'deposit.information',
                    component: Information,
                    props: { next: 'deposit.contract' },
                }, {
                    path: '/deposit/contract',
                    name: 'deposit.contract',
                    component: Contract,
                    props: { next: 'deposit.upload' },
                    meta: { tracking: 'PLATFORM_CONTRACT_VIEW' },
                }, {
                    path: '/deposit/upload',
                    name: 'deposit.upload',
                    component: Upload,
                    props: { next: 'deposit.thanks' },
                    meta: { tracking: 'PLATFORM_UPLOAD_VIEW' },
                }, {
                    path: '/deposit/thanks',
                    name: 'deposit.thanks',
                    component: Thanks,
                    meta: { tracking: 'PLATFORM_THANKS_VIEW' },
                },
            ],
        }, {
            path: '/profile',
            name: 'profile',
            redirect: '/profile/about',
            component: Profile,
            meta: { auth: true },
            children: [
                {
                    path: '/profile/about',
                    name: 'profile.about',
                    component: ProfileAbout,
                }, {
                    path: '/profile/videos',
                    name: 'profile.videos',
                    component: ProfileVideos,
                },
            ],
        }, {
            path: '/profile/edit/general',
            name: 'profile.edit.general',
            component: ProfileEditGeneral,
            meta: { auth: true },
        }, {
            path: '/profile/edit/social',
            name: 'profile.edit.social',
            component: ProfileEditSocial,
            meta: { auth: true },
        }, {
            path: '/profile/edit/address',
            name: 'profile.edit.address',
            component: ProfileEditAddress,
            props: (route) => ({
                ...route.params,
            }),
            meta: { auth: true },
        }, {
            path: '/profile/privacy',
            name: 'profile.privacy',
            component: ProfilePrivacy,
            meta: { auth: true },
        }, {
            path: '/profile/edit/preferences',
            name: 'profile.edit.preferences',
            component: ProfileEditPreferences,
            meta: { auth: true },
        }, {
            path: '/project/:projectID',
            name: 'project',
            component: Project,
            props: true,
            meta: { auth: true },
        }, {
            path: '/help',
            name: 'help',
            component: Help,
            meta: { auth: true },
        }, {
            path: '/forbidden',
            name: 'forbidden',
            component: Forbidden,
        }, {
            path: '*',
            name: 'not-found',
            component: NotFound,
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});
